document.addEventListener('DOMContentLoaded', function () {
  (function() {
      var newSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.02382 8.49998C2.02382 4.69974 5.10452 1.61904 8.90474 1.61904C12.705 1.61904 15.7857 4.69974 15.7857 8.49998C15.7857 12.3002 12.705 15.3809 8.90474 15.3809C7.55106 15.3809 6.29102 14.9909 5.22788 14.3173C5.03002 14.192 4.78758 14.1585 4.56315 14.2254L2.23241 14.921L3.10997 12.8676C3.21369 12.6249 3.19259 12.3469 3.05341 12.1227C2.4008 11.071 2.02382 9.83075 2.02382 8.49998ZM8.90474 0C4.21035 0 0.404778 3.80557 0.404778 8.49998C0.404778 9.98796 0.787796 11.3886 1.46091 12.6064L0.0651434 15.8723C-0.0582455 16.1611 -0.00355265 16.4951 0.205474 16.7293C0.414501 16.9637 0.740163 17.056 1.04104 16.9661L4.68342 15.8792C5.92769 16.5924 7.36965 17 8.90474 17C13.5992 17 17.4047 13.1944 17.4047 8.49998C17.4047 3.80557 13.5992 0 8.90474 0ZM10.7606 10.2667L9.6967 11.0161C9.19844 10.7322 8.64756 10.3361 8.09498 9.78348C7.52054 9.20904 7.09467 8.61599 6.78066 8.07199L7.45675 7.49812C7.74689 7.25186 7.8263 6.83668 7.64756 6.50069L6.7861 4.88164C6.67009 4.66363 6.46093 4.51049 6.21806 4.46576C5.97519 4.42103 5.72519 4.48961 5.53913 4.65199L5.28372 4.8749C4.66951 5.41096 4.30625 6.29185 4.60732 7.18378C4.91945 8.10842 5.58557 9.56369 6.95017 10.9283C8.4183 12.3965 9.9096 12.9746 10.7817 13.1992C11.4844 13.38 12.1493 13.1376 12.6179 12.7558L13.0967 12.3656C13.3015 12.1988 13.412 11.9424 13.3927 11.6789C13.3734 11.4154 13.2267 11.1779 12.9997 11.0426L11.6411 10.2331C11.3667 10.0696 11.0218 10.0828 10.7606 10.2667Z" fill="black"/></svg>';

      function replaceSvg() {
        document.querySelectorAll('.contact_us').forEach(function(el) {
          var svg = el.querySelector('svg');
          if (svg && svg.getAttribute('viewBox') === '0 0 19 18') {
            svg.outerHTML = newSvg;
          }
        });
      }

      var observer = new MutationObserver(function() {
        replaceSvg();
      });
      observer.observe(document.body, { childList: true, subtree: true });

      replaceSvg();

      document.addEventListener('click', function() {
        setTimeout(replaceSvg, 50);
        setTimeout(replaceSvg, 200);
        setTimeout(replaceSvg, 500);
      });
    })();
    
  // 创建 IntersectionObserver 实例

  class YGPopupBox extends YGUtils {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup ($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup (e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends YGUtils {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init () {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick () {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }


  class YGSwiper extends YGUtils {
    constructor() {
      super()
    }
    connectedCallback () {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView () {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes () {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides','loop','autoplay'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints (str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }
      return result;
    }

    initSwiper () {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        speed: 4000,
        autoplay:this['autoplay'] ?  {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        }:false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
          prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
        } : false,
        scrollbar: this['scrollbar'] ? {
          el: ".swiper-scrollbar",
          hide: true,
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }
  class YGRichtext extends YGUtils {
    constructor() {
      super()
      this.$btnList = this.btnList
      this.$itemList = this.itemList
      this.$headerList = this.headerList
    }
    get btnList () {
      if (!this.$btnList) {
        this.$btnList = this.querySelectorAll('.yg-richtext__icon')
      }
      return this.$btnList
    }
    get itemList () {
      if (!this.$itemList) {
        this.$itemList = this.querySelectorAll('.yg-richtext__content')
      }
      return this.$itemList
    }
    get headerList () {
      if (!this.$headerList) {
        this.$headerList = this.querySelectorAll('.yg-richtext__header')
      }
      return this.$headerList
    }

    handClick (e, i) {
      if (this.$itemList[i].classList.contains('active')) {
        this.$itemList[i].classList.remove('active')
        this.$btnList[i].classList.remove('active')
        this.$itemList[i].style.maxHeight = 0 + 'px'
      } else {
        const height = this.$itemList[i].scrollHeight
        this.$itemList[i].classList.add('active')
        this.$itemList[i].style.maxHeight = height + 'px'
        this.$btnList[i].classList.add('active')
      }
    }
    connectedCallback () {
      this.$headerList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
    }

  }
  if (!window.customElements.get('yg-richtext')) {
    window.customElements.define('yg-richtext', YGRichtext)
  }


    class YGTab extends YGUtils {
    constructor() {
      super()
      this.$btnList = this.btnList
      this.$itemList = this.itemList
    }
    get btnList () {
      if (!this.$btnList) {
        this.$btnList = this.querySelectorAll('.yg-tab-item')
      }
      return this.$btnList
    }
    get itemList () {
      if (!this.$itemList) {
        this.$itemList = this.querySelectorAll('.yg-tab-content')
      }
      return this.$itemList
    }

    handClick (e, i) {
        this.$itemList.forEach(item => item.classList.remove('active'))
        this.$btnList.forEach(item => item.classList.remove('active'))
        this.$btnList[i].classList.add('active')
        this.$itemList[i].classList.add('active')
        
    }
    connectedCallback () {
      // 初始化时给第一项添加active类
      if (this.$btnList.length > 0) {
        this.$btnList[0].classList.add('active');
      }
      if (this.$itemList.length > 0) {
        this.$itemList[0].classList.add('active');
      }
      
      this.$btnList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
    }


  }
  if (!window.customElements.get('yg-tab')) {
    window.customElements.define('yg-tab', YGTab)
  }
  
  // yg-selection-swiper

  class YGProductSeriesList extends YGUtils {
    constructor() {
      super();
      this.init();
    }

    init() {
      let activeIndex = 0;

      const seriesList = this.querySelectorAll('.yg-collection');
      const productListList = this.querySelectorAll('.yg-content');

      if (!seriesList.length || !productListList.length) return;

      seriesList[activeIndex].classList.add('yg-collection-active');
      productListList[activeIndex].style.display = 'block';

      seriesList.forEach((series, index) => {
        series.addEventListener('click', () => {
          seriesList[activeIndex].classList.remove('yg-collection-active');
          productListList[activeIndex].style.display = 'none';

          activeIndex = index;

          seriesList[activeIndex].classList.add('yg-collection-active');
          productListList[activeIndex].style.display = 'block';
        });
      });
    }
  }

  if (!window.customElements.get('yg-product-series-list')) {
    window.customElements.define('yg-product-series-list', YGProductSeriesList);
  }


  /* ===============================
   * Product Swiper
   * =============================== */
  class YGImgSwiper2 extends YGUtils {
    constructor() {
      super();
      this.init();
    }

    init() {
      new Swiper(this, {
        spaceBetween: 12,
        slidesPerView: 1.2,

        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'progressbar',
        },

        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },

        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    }
  }

  if (!window.customElements.get('yg-img-swiper-2')) {
    window.customElements.define('yg-img-swiper-2', YGImgSwiper2);
  }


  /* ===============================
   * Nav Swiper
   * =============================== */
  class YGNavSwiper extends YGUtils {
    constructor() {
      super();
      const url = this.getAttribute('data-load-script');

      if (url) {
        this.loadScript(url, () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      new Swiper(this, {
        spaceBetween: 0,
        slidesPerView: 'auto',

        breakpoints: {
          1150: {
            slidesPerView: this.querySelectorAll('.swiper-slide').length
          }
        },

        navigation: {
          nextEl: this.closest('yg-product-series-list')?.querySelector('.yg-swiper-button-next'),
          prevEl: this.closest('yg-product-series-list')?.querySelector('.yg-swiper-button-prev'),
        },
      });
    }
  }

  if (!window.customElements.get('yg-nav-swiper')) {
    window.customElements.define('yg-nav-swiper', YGNavSwiper);
  }


  /* ===============================
   * Scroll Button
   * =============================== */
  document.querySelectorAll('.yg-series-list').forEach(list => {
    const scrollBtn = list.parentElement.querySelector('.yg-sroll-btn');

    if (!scrollBtn) return;

    if (list.scrollWidth > list.clientWidth) {
      scrollBtn.style.display = 'block';
    }

    scrollBtn.addEventListener('click', () => {
      list.scrollLeft += 100;
    });
  });

  function shouldHideStableLensButtonOnMobile() {
    return (document.body.classList.contains('yg-sunglasses-product')
      || document.body.classList.contains('sunglasses-no-lenses'))
      && window.matchMedia('(max-width: 767px)').matches;
  }

  function findLensTrigger() {
    return document.querySelector('lensadvizor-btn.la-select-lenses-btn')
      || document.querySelector('.la-select-lenses-btn:not(.yg-select-lenses-stable-btn)')
      || document.querySelector('.sb_customize-btn')
      || document.querySelector('.sb-el-drawer');
  }

  function findStoredLensTrigger() {
    const lensAdvizor = window.LensAdvizor;
    if (!lensAdvizor || !lensAdvizor.selectLensButtons) return null;
    const keys = Object.keys(lensAdvizor.selectLensButtons);
    for (const key of keys) {
      const button = lensAdvizor.selectLensButtons[key];
      if (button && typeof button.click === 'function') return button;
    }
    return null;
  }

  function bindLensEvents() {
    if (window.LensAdvizor && typeof window.LensAdvizor.addEventListeners === 'function') {
      try {
        window.LensAdvizor.addEventListeners();
      } catch (error) {
        // LensAdvizor may throw while its remote settings request is pending.
      }
    }
  }

  function isLensReady() {
    const lensAdvizor = window.LensAdvizor;
    return Boolean(
      lensAdvizor
      && lensAdvizor.settings
      && lensAdvizor._options
      && Object.keys(lensAdvizor._options).length
    );
  }

  function setLensButtonStatus(message) {
    const stableButton = document.querySelector('.yg-select-lenses-stable-btn');
    if (!stableButton) return;

    stableButton.textContent = message;
    stableButton.setAttribute('aria-label', message);
    stableButton.setAttribute('aria-busy', 'true');

    window.clearTimeout(window.ygLensButtonStatusTimer);
    window.ygLensButtonStatusTimer = window.setTimeout(() => {
      stableButton.textContent = 'Select Lenses and Buy';
      stableButton.setAttribute('aria-label', 'Select Lenses and Buy');
      stableButton.removeAttribute('aria-busy');
    }, 2400);
  }

  function triggerStableLensButton() {
    if (!isLensReady()) {
      bindLensEvents();
      setLensButtonStatus('Loading lens options...');
      return;
    }

    bindLensEvents();
    const target = findLensTrigger() || findStoredLensTrigger();
    if (target) target.click();
  }

  document.addEventListener('click', (event) => {
    const stableButton = event.target.closest?.('.yg-select-lenses-stable-btn');
    if (!stableButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    triggerStableLensButton();
  }, true);

  function syncLensButtonsFallback() {
    if (typeof window.ygSyncLensButtonsStable === 'function') {
      window.ygSyncLensButtonsStable();
    }

    const buttonGroup = document.querySelector('body.product-template .product__info-wrapper .product-form__buttons');

    if (!buttonGroup) return;
  }

  syncLensButtonsFallback();
  setTimeout(syncLensButtonsFallback, 300);
  setTimeout(syncLensButtonsFallback, 1000);
  setTimeout(syncLensButtonsFallback, 2500);
  setTimeout(syncLensButtonsFallback, 5000);
  setTimeout(syncLensButtonsFallback, 9000);
  setTimeout(syncLensButtonsFallback, 15000);
  window.addEventListener('resize', syncLensButtonsFallback);

  const lensOpenUrl = new URL(window.location.href);

  if (lensOpenUrl.searchParams.get('open_lenses') === '1') {
    lensOpenUrl.searchParams.delete('open_lenses');
    window.history.replaceState({}, '', lensOpenUrl);

    let lensOpenAttempts = 0;
    const lensOpenTimer = window.setInterval(() => {
      const lensButton = document.querySelector('#la-select-lenses-btn');
      lensOpenAttempts += 1;

      if (
        lensButton
        && typeof lensButton.launchLensAdvizorModal === 'function'
        && window.LensAdvizor?.loadingCompleted
      ) {
        window.clearInterval(lensOpenTimer);
        lensButton.click();
      } else if (lensOpenAttempts >= 40) {
        window.clearInterval(lensOpenTimer);
      }
    }, 250);
  }
  // end yg-selection-swiper
})
